import "./Modal.css";

const Modal = ({ modalData, setOpenModal }) => {
  console.log("modelllll", modalData);
  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>{"Payment Details"}</h3>
        <div className="dialog-data">
        <p>
            <span>Amount-</span>
            ₹{modalData &&
              modalData.dataItem &&
              modalData.dataItem.amount}
          </p>
          <p>
            <span>Customer Name- </span>
            {modalData &&
              modalData.dataItem &&
              modalData.dataItem.customerName &&
              modalData.dataItem.customerName}
          </p>
         
          <p>
            <span>Customer Mobile - </span>{" "}
            {modalData &&
              modalData.dataItem &&
              modalData.dataItem.customerMobile &&
              modalData.dataItem.customerMobile}
          </p>

          <p>
            <span>Customer Email - </span>{" "}
            {modalData &&
              modalData.dataItem &&
              modalData.dataItem.customerEmail &&
              modalData.dataItem.customerEmail}
          </p>
          <p>
            <span>Order ID- </span>
            {modalData &&
              modalData.dataItem &&
              modalData.dataItem.orderId &&
              modalData.dataItem.orderId}
          </p>
          <p>
            <span>Org Name - </span>
            {modalData.orgName || "N/A"}
          </p>
          <p>
            <span>PG - </span>
            {modalData.pg || "N/A"}
          </p>
          <p>
            <span>Type - </span>
            {modalData.type || "N/A"}
          </p>
          <p>
            <span>Customer VPA - </span>{" "}
            {modalData &&
              modalData.dataItem &&
              modalData.dataItem.vpa &&
              modalData.dataItem.vpa}
          </p>
          <p>
            <span>Transaction Mode- </span>
            {modalData &&
              modalData.dataItem &&
              modalData.dataItem.transactionMode &&
              modalData.dataItem.transactionMode}
          </p>
          <p>
            <span>Transaction Id- </span>
            {modalData && modalData.transactionId && modalData.transactionId}
          </p>
          <p>
            <span>Ref Id- </span>
            {modalData && modalData.referenceId && modalData.referenceId}
          </p>
         
          {/* <p>
            <span>Status- </span>
            {modalData &&
              modalData.resposne &&
              modalData.resposne.RESPONSE_MESSAGE &&
              modalData.resposne.RESPONSE_MESSAGE}
          </p> */}
        </div>

        <div className="modal-button">
          <button className="view-btn" onClick={() => setOpenModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
